import { useExamContext } from "@features/exam/contexts/ExamContext";
import { SessionConfigDialog } from "@features/session-config/components/SessionConfigDialog";
import { getShowStudyPackViews } from "@helpers/exams";
import { images } from "@helpers/images";
import { useAppStore } from "@hooks/useAppStore";
import useBreakpoints from "@hooks/useBreakpoints";
import { useCustomNavigation } from "@hooks/useCustomNavigation";
import Box from "@memorang/ui/components/Box";
import { NavigationRail } from "@memorang/ui/components/Navigation/NavigationRail";
import { QuickStudyButton } from "@memorang/ui/components/Navigation/QuickStudyButton";
import StoresDownloadBadge from "components/StoresDownloadBadge";
import { router, usePathname } from "expo-router";
import { useState } from "react";
import { ScrollView } from "react-native";
import { Drawer } from "../../../CustomDrawer";
import { drawerWidths } from "../constants";
import { useDrawerNavItems } from "../hooks/useDrawerNavItems";

export const AppDrawer = () => {
	const appLogo = useAppStore((s) => s.app.logo);
	const appLinksIos = useAppStore((s) => s.app.links.ios);
	const appLinksAndroid = useAppStore((s) => s.app.links.android);
	const isStudyPackEnabled = useAppStore((s) => s.app.isStudyPackEnabled);
	const {
		currentExamContext: { examId, studyPackCollectionId },
	} = useExamContext();
	const { smUp, mdDown } = useBreakpoints();
	const { handleSessionConfigNavigation } = useCustomNavigation();
	const isCollapsed = smUp && mdDown;
	const [showSessionConfigDialog, setShowSessionConfigDialog] = useState(false);
	const toggleSessionConfigDialog = () => {
		setShowSessionConfigDialog((prev) => !prev);
	};

	const showStudyPackViews = getShowStudyPackViews(studyPackCollectionId);

	const { items, routeMap } = useDrawerNavItems();
	const pathname = usePathname();
	const activeItemKey = pathname.split("/")[1] || "";

	return (
		<Box flex={1} overflow="hidden">
			<Drawer
				drawerContent={() => (
					<ScrollView
						showsVerticalScrollIndicator={false}
						contentContainerStyle={{
							flexGrow: 1,
						}}
					>
						<NavigationRail
							logo={appLogo}
							items={items}
							activeItemKey={activeItemKey}
							isCollapsed={isCollapsed}
							onPressItem={(key) => {
								const route = routeMap[key];
								if (route) {
									router.push(route);
								}
							}}
							onPressLogo={() => router.push("/home")}
							onPressAccount={() => router.push("/account/settings")}
							renderFab={() => (
								<QuickStudyButton
									enabled={isStudyPackEnabled && showStudyPackViews}
									isLoading={!examId}
									isCollapsed={isCollapsed}
									onPress={() => {
										handleSessionConfigNavigation(toggleSessionConfigDialog, {
											reset: "true",
										});
									}}
								/>
							)}
							renderFooter={
								isCollapsed
									? undefined
									: () => (
											<StoresDownloadBadge
												ios={{
													badge: images.appStores.ios,
													href: appLinksIos,
												}}
												android={{
													badge: images.appStores.android,
													href: appLinksAndroid,
												}}
											/>
										)
							}
						/>
					</ScrollView>
				)}
				screenOptions={{
					drawerType: smUp ? "permanent" : "slide",
					headerTitle: "",
					drawerStyle: {
						width: isCollapsed ? drawerWidths.collapsed : drawerWidths.expanded,
						borderRightColor: "transparent",
					},
					header: () => null,
				}}
			/>
			{showSessionConfigDialog ? (
				<SessionConfigDialog
					visible={showSessionConfigDialog}
					handleClose={toggleSessionConfigDialog}
				/>
			) : null}
		</Box>
	);
};
